<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/files/blue</title>
    <g id="atoms/icons/24x24/files/blue" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M9.125,3 L12.6875,5.77279937 L18.625,5.77279937 C19.9366763,5.77279937 21,6.83687756 21,8.14948454 L21,18.6233148 C21,19.9359218 19.9366763,21 18.625,21 L4.375,21 C3.06332372,21 2,19.9359218 2,18.6233148 L2,5.37668517 C2,4.0640782 3.06332372,3 4.375,3 L9.125,3 Z M8.58270833,4.58445678 L4.375,4.58445678 C3.93777457,4.58445678 3.58333333,4.93914951 3.58333333,5.37668517 L3.58333333,18.6233148 C3.58333333,19.0608505 3.93777457,19.4155432 4.375,19.4155432 L18.625,19.4155432 C19.0622254,19.4155432 19.4166667,19.0608505 19.4166667,18.6233148 L19.4166667,8.14948454 C19.4166667,7.71194888 19.0622254,7.35725615 18.625,7.35725615 L12.1442461,7.35725615 L11.7154274,7.02349384 L8.58270833,4.58445678 Z M11.5,13.2561459 L11.5,14.8561459 L5.21546125,14.8561459 L5.21546125,13.2561459 L11.5,13.2561459 Z M13.3674161,10.1728787 L13.3674161,11.7728787 L5.21546125,11.7728787 L5.21546125,10.1728787 L13.3674161,10.1728787 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
